import { INDIVIDUAL_PLUSES_LIST } from '@/page-content/individual-lessons/constants/pluses-list';
import { Article } from '@/shared/components/article';
import { TextPlusesList } from '@/shared/components/text-pluses-list';
export const PlusesIndividualLessons = () => {
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">Плюсы индивидуальных занятий по английскому</h2>

      <TextPlusesList items={INDIVIDUAL_PLUSES_LIST} />
    </Article>;
};